import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <rect width={29} height={29} fill={props.fillSecondary} rx={10} />
      <path
        fill={props.fillPrimary}
        d="M14.497 4.307l10.6 4.368v1.458H23.69a.686.686 0 01-.226.512.746.746 0 01-.535.216H6.073a.75.75 0 01-.535-.216.687.687 0 01-.227-.512H3.897V8.675zm-7.772 7.28h2.827v8.736h1.413v-8.736h2.832v8.736h1.41v-8.736h2.828v8.736h1.414v-8.736h2.828v8.736h.651a.75.75 0 01.535.216.685.685 0 01.226.512v.729H5.311v-.729a.686.686 0 01.226-.512.746.746 0 01.535-.216h.651v-8.736zm17.616 10.92a.75.75 0 01.535.216.685.685 0 01.226.512v1.458H3.897v-1.457a.686.686 0 01.226-.512.746.746 0 01.535-.217h19.683z"
      />
    </svg>
  );
}

export default SvgComponent;
